import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthSessionService } from '../services/auth-session.service';
import { isConfiguredApiRequest } from './api-request.util';

/**
 *
 * Función utilizada para agregar el token de sesión a las peticiones dirigidas a los APIs configurados cuando aún no lo incluyen
 */
export const authTokenInterceptor: HttpInterceptorFn = (request, next) => {
  const token = inject(AuthSessionService).accessToken();
  if (!token || request.headers.has('token') || !isConfiguredApiRequest(request.url)) {
    return next(request);
  }

  return next(
    request.clone({
      setHeaders: { token: ` ${token}` },
    }),
  );
};
